import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UserSuggestions = ({ suggestions, onFollow, onViewProfile }) => {
  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-lg text-accent-800">Suggested for You</h3>
        <button className="text-primary text-sm font-medium hover:text-primary-600 transition-colors">
          See All
        </button>
      </div>
      
      <div className="space-y-4">
        {suggestions.map((user) => (
          <div key={user.id} className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="relative">
                <Image
                  src={user.avatar}
                  alt={user.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                {user.isVerified && (
                  <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-primary rounded-full flex items-center justify-center">
                    <Icon name="Check" size={10} color="white" />
                  </div>
                )}
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2">
                  <h4 className="font-semibold text-accent-800 truncate">{user.name}</h4>
                  {user.badge && (
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-600 text-xs rounded-full font-medium">
                      {user.badge}
                    </span>
                  )}
                </div>
                <p className="text-sm text-accent-500 truncate">{user.bio}</p>
                <div className="flex items-center space-x-4 mt-1">
                  <span className="text-xs text-accent-400">
                    {user.followersCount} followers
                  </span>
                  <span className="text-xs text-accent-400">
                    {user.postsCount} posts
                  </span>
                </div>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <Button
                variant="ghost"
                size="sm"
                iconName="User"
                onClick={() => onViewProfile(user.id)}
                className="text-accent-500"
              />
              <Button
                variant="primary"
                size="sm"
                onClick={() => onFollow(user.id)}
                className="px-4"
              >
                Follow
              </Button>
            </div>
          </div>
        ))}
      </div>
      
      <button className="w-full mt-4 p-3 text-center text-primary font-medium hover:bg-primary-50 rounded-xl transition-colors duration-200">
        View More Suggestions
      </button>
    </div>
  );
};

export default UserSuggestions;